import type { GlobalStateCommandFactory } from 'components/GlobalState/GlobalStateModel';

interface SetMinimisedMenuCommand {
  value: boolean;
}

export const setMinimisedMenu: GlobalStateCommandFactory<
  SetMinimisedMenuCommand
> = (cmdContext) => (command) => {
  cmdContext.updateState((draft) => {
    draft.minimisedMenu = command.value;
  });
};
